module.exports = __webpack_public_path__ + "static/apple_store.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/apple_store.svg
// module id = 214
// module chunks = 193162123475590 216210090109534